<template>
    <div class="bg-wrap-color">
        <div class="p20 bg-color mb10 mi_create_header_fixed"  :style="{width: fixWidth}">
            <span style="font-size: 14px;font-weight: 600;padding-right: 20px;cursor: pointer;" @click="handleClick" v-matomo="{behaviorCategory: '小米(批量搭建)',  name: '列表(任务详情-返回)' }"><i class="el-icon-back"></i>返回</span>任务ID： {{id}}
        </div>
        <div style="height: 70px;"></div>
        <div class="pl20 pr20 pt10 pb10 bg-color mb10" id="mi_create_body">
            <p class="text-bold">目标账户与产品：</p>
            <p>
                <span class="text-bold"> 账户：</span> {{account_info.account_name}}（ID：{{account_info.account_id}}）；
                <span class="text-bold"> 产品：</span> {{app_info.map(item=>item.app_name+'('+item.app_id+')').join('、')}}
            </p>
        </div>

        <el-table :data="tableData"
        style="width: 100%;margin-top: 10px;"
        stripe
        :header-cell-style="{background:'#e8eaec',color:'#333'}"
        :row-class-name="tableRowClassName"
        size="mini"
        row-key="id"
        class="create_vivo_list"
        v-loading="loading"
        tooltip-effect="dark">
            <el-table-column label="状态" width="150">
                <template slot-scope="scope">
                    <div v-if="scope.$index==0">
                        <p><span class="text-bold">总计</span>(成功/失败)</p>
                        <!-- <p>{{gather.ad_total}}({{gather.ad_num}} / {{gather.ad_err_num}})</p> -->
                    </div>
                    <!-- 1-创建中，2-成功，3-计划失败，4-广告组失败，5-广告失败  -->
                    <p v-else-if="scope.row.status == 1" class="text-color-info">{{ scope.row.status_text}}<i class="el-icon-loading"></i></p>
                    <p v-else-if="scope.row.status == 2" class="text-color-success">{{ scope.row.status_text}}</p>
                    <p v-else class="text-color-error"><el-tooltip class="item" effect="dark" :content="scope.row.err_msg" placement="top"><span class="pointer">{{ scope.row.status_text}}<i class="el-icon-warning-outline"></i></span></el-tooltip></p>
                </template>
            </el-table-column>
            <el-table-column label="计划" min-width="200">
                <template slot-scope="scope">
                    <span v-if="scope.$index==0">{{gather.plan_num}} / {{gather.plan_err_num}}</span>
                    <div v-else>
                        <p class="ellipsis-row-2">
                            <el-tooltip class="item" effect="dark" :content="scope.row.plan_name" placement="top">
                                <span>{{ scope.row.plan_name||'-' }}</span>
                            </el-tooltip>
                        </p>
                        <p class="ellipsis" v-if="scope.row.plan_id">ID:{{scope.row.plan_id}}</p>
                    </div>
                </template>
            </el-table-column>
            <el-table-column label="投放范围" min-width="200"  show-overflow-tooltip>
                <template slot-scope="scope">
                    <span v-if="scope.$index==0"></span>
                    <span v-else-if="scope.row.campaign_type=='1'">商店</span>
                    <span v-else-if="scope.row.campaign_type=='2'">非商店</span>
                    <span v-else-if="scope.row.campaign_type=='3'">米盟</span>
                    <span v-else>-</span>
                </template>
            </el-table-column>
            <el-table-column label="广告组" min-width="200">
                <template slot-scope="scope">
                    <span v-if="scope.$index==0">{{gather.adgroup_num}} / {{gather.adgroup_err_num}}</span>
                    <div v-else>
                        <p class="ellipsis-row-2">
                            <el-tooltip class="item" effect="dark" :content="scope.row.adgroup_name" placement="top">
                                <span>{{ scope.row.adgroup_name||'-' }}</span>
                            </el-tooltip>
                        </p>
                        <p class="ellipsis" v-if="scope.row.adgroup_id">ID:{{scope.row.adgroup_id}}</p>
                    </div>
                </template>
            </el-table-column>
            <el-table-column label="版位" min-width="200"  show-overflow-tooltip>
                <template slot-scope="scope">
                    <span v-if="scope.$index==0"></span>
                    <span v-else>{{scope.row.display_type_text||'-'}}</span>
                </template>
            </el-table-column>
            <el-table-column label="应用" min-width="200"  show-overflow-tooltip>
                <template slot-scope="scope">
                    <span v-if="scope.$index==0"></span>
                    <span v-else>{{scope.row.app_name||'-'}}</span>
                </template>
            </el-table-column>
            <el-table-column label="广告创意" min-width="200">
                <template slot-scope="scope">
                    <span v-if="scope.$index==0">{{gather.ad_num}} / {{gather.ad_err_num}}</span>
                    <div v-else>
                        <p class="ellipsis-row-2">
                            <el-tooltip class="item" effect="dark" :content="scope.row.ad_name" placement="top">
                                <span>{{ scope.row.ad_name||'-' }}</span>
                            </el-tooltip>
                        </p>
                        <p class="ellipsis" v-if="scope.row.ad_id">ID:{{scope.row.ad_id}}</p>
                    </div>
                </template>
            </el-table-column>

            <el-table-column label="广告描述" min-width="200">
                <template slot-scope="scope">
                    <span v-if="scope.$index==0"></span>
                    <div v-else>
                        <p class="ellipsis-row-2">
                            <el-tooltip class="item" effect="dark" :content="scope.row.description" placement="top">
                                <span>{{ scope.row.description||'-' }}</span>
                            </el-tooltip>
                        </p>
                    </div>
                </template>
            </el-table-column>
            <el-table-column label="推广产品描述" min-width="200">
                <template slot-scope="scope">
                    <span v-if="scope.$index==0"></span>
                    <div v-else>
                        <p class="ellipsis-row-2">
                            <el-tooltip class="item" effect="dark" :content="scope.row.product_description" placement="top">
                                <span>{{ scope.row.product_description||'-' }}</span>
                            </el-tooltip>
                        </p>
                    </div>
                </template>
            </el-table-column>
            <el-table-column label="广告品牌描述" min-width="200">
                <template slot-scope="scope">
                    <span v-if="scope.$index==0"></span>
                    <div v-else>
                        <p class="ellipsis-row-2">
                            <el-tooltip class="item" effect="dark" :content="scope.row.brand" placement="top">
                                <span>{{ scope.row.brand||'-' }}</span>
                            </el-tooltip>
                        </p>
                    </div>
                </template>
            </el-table-column>

            <el-table-column label="转化类型" min-width="200"  show-overflow-tooltip>
                <template slot-scope="scope">
                    <span v-if="scope.$index==0"></span>
                    <span v-else>{{scope.row.conversion_type_text||'-'}}</span>
                </template>
            </el-table-column>
            <el-table-column label="转化名称" min-width="200"  show-overflow-tooltip>
                <template slot-scope="scope">
                    <span v-if="scope.$index==0"></span>
                    <span v-else>{{scope.row.conversion_name||'-'}}</span>
                </template>
            </el-table-column>
            <el-table-column label="素材规格" min-width="200"  show-overflow-tooltip>
                <template slot-scope="scope">
                    <span v-if="scope.$index==0"></span>
                    <span v-else>{{scope.row.emi_material_type_text||'-'}}</span>
                </template>
            </el-table-column>
            <el-table-column label="创意类型" min-width="200"  show-overflow-tooltip>
                <template slot-scope="scope">
                    <span v-if="scope.$index==0"></span>
                    <span v-else>{{scope.row.placement_type_text||'-'}}</span>
                </template>
            </el-table-column>
            <el-table-column label="广告标题" min-width="200"  show-overflow-tooltip>
                <template slot-scope="scope">
                    <span v-if="scope.$index==0"></span>
                    <span v-else>{{scope.row.title||'-'}}</span>
                </template>
            </el-table-column>
            <el-table-column label="创意" min-width="300">
                <template slot-scope="scope">
                    <span v-if="scope.$index==0"></span>
                    <template v-else>
                        <IdeaColumnTemp :list="scope.row.creative_list||[]" />
                        <span v-if="(scope.row.creative_list||[]).length<=0">-</span>
                    </template>
                </template>
            </el-table-column>
        </el-table>

        <div class="bg-color tar p20">
            <el-pagination
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :current-page="currentPage"
                :page-sizes="[10, 30, 50, 100]"
                :page-size="pageSize"
                layout="total, sizes, prev, pager, next, jumper"
                :total="total"
            >
            </el-pagination>
        </div>

    </div>
</template>

<script>
import { mapGetters } from 'vuex'
import API from '@/api/marketManage/miBatch.js';
import IdeaColumnTemp from '../components/ideaColumnTemp';
export default {
    name: "infopage",
    components: {
        IdeaColumnTemp,
    },
    props:{
        id: ''
    },
    data() {
        return {
            gather: {               //数据汇总
                plan_num:'',
                plan_total:'',
                adgroup_num:'',
                agroup_total:'',
                ad_num:'',
                ad_total:'',
            },
            params:{},  //创意详情
            loading:true,  // 表格loading
            currentPage: 1,
            pageSize: 10,
            total: 10,
            refreshTimer: null, //定时器
            equal: 1, //缓存请求赋值
            status_err:[],
            tableData: [],
            dialogVisible: false,
            account_info:{
                account_id:'',
                account_name:'',
            },
            app_info:[],
            confirmTip:null,
            fixWidth: '1000px',
            queryParams:{},
        }
    },
    computed:{
        ...mapGetters(['sidebar']),
    },
    watch:{
        sidebar: {
        handler(n, o){
            setTimeout(()=>{
            this.getFixWidth()
            }, 300)
        },
        deep: true
        }
    },
    mounted() {
        this.getFixWidth()
        window.addEventListener('resize', this.getFixWidth);

        this.init()
    },
    methods: {
        getFixWidth() {
            let mi_create_body = document.getElementById('mi_create_body')
            if(mi_create_body) {
                let mi_width = mi_create_body.clientWidth
                this.fixWidth = `${mi_width}px`
            }
        },
        toConfigPage() {
            this.$emit("changePage", "config")
        },
        // 每页条数
        handleSizeChange(val) {
            this.pageSize = val
            this.init()
        },
        // 当前页数
        handleCurrentChange(val) {
            this.currentPage = val
            this.init()
        },
        handleClick() {
            this.stopRefresh()
            this.$emit("changePage", "listPage")
        },
        init() {
            let obj = {pn: this.currentPage, rn: this.pageSize, task_id:this.id}
            this.loading = true
            this.polling(obj)
        },
        polling(params) {
            clearInterval(this.refreshTimer)
            this.refreshTimer = null
            this.queryParams = {...params};
            API.getDetailDataAccountAppInfo(params).then(res=>{
                let resData = res.data||{};
                this.account_info = resData.account_info;
                this.app_info = resData.app_info||[];
                this.gather = resData.total_info||{};
                API.getDetailDataList(params).then(res1=>{
                    let result = res1.data
                    this.loading = false

                    let createarr = []
                    let resultList = result.list||[];
                    resultList.forEach(element => {
                        if(element.status == 1) {
                            createarr.push(element.id)
                        }
                    });


                    // this.equal++
                    this.tableData = [this.gather].concat(resultList.map(((item, index)=>{
                        item.id = index
                        item.expend = false
                        return item
                    })));
                    this.currentPage = result.pageNum
                    this.pageSize = result.pageSize
                    this.total = result.totalCnt
                    // if(createarr.length != 0) {
                    //     let obj = {pn: this.currentPage, rn: this.pageSize, task_id:this.id}
                    //     this.monitor = setTimeout(()=>{
                    //         console.log('monitor','info page');
                    //         this.polling(obj);
                    //     }, 5000)
                    // }
                    // this.startRefresh();

                },err1=>{
                    this.loading = false;
                    if (err1.code == '403') {
                        if(this.confirmTip) return;
                        this.confirmTip = this.$confirm(err1.info||'请求异常', '提示', {
                            confirmButtonText: '刷新',
                            type: 'warning',
                            showClose: false,
                            closeOnClickModal: false,
                            closeOnPressEscape: false
                        }).then(() => {
                            window.location.reload()
                            this.confirmTip = null;
                        }).catch(() => {
                            this.confirmTip = null;
                        });
                        return
                    }
                    this.$message.error(err1.info)
                })
            },err=>{
                this.loading = false;
                if (err.code == '403') {
                    if(this.confirmTip) return;
                    this.confirmTip = this.$confirm(err.info||'请求异常', '提示', {
                        confirmButtonText: '刷新',
                        type: 'warning',
                        showClose: false,
                        closeOnClickModal: false,
                        closeOnPressEscape: false
                    }).then(() => {
                        window.location.reload()
                        this.confirmTip = null;
                    }).catch(() => {
                        this.confirmTip = null;
                    });
                    return
                }
                this.$message.error(err.info)
            })

        },
        startRefresh(){
            if(this.refreshTimer) return;

            this.refreshTimer = setInterval(()=>{
                if(this.tableData.some(item=>item.status=='1')){
                    let obj = {...this.queryParams}
                    API.getDetailDataAccountAppInfo(obj).then(res=>{
                        let resData = res.data||{};
                        this.account_info = resData.account_info;
                        this.app_info = resData.app_info||[];
                        this.gather = resData.total_info||{};
                        API.getDetailDataList(obj).then(res1=>{
                            let result = res1.data
                            let resultList = result.list||[];
                            this.tableData = [this.gather].concat(resultList.map(((item, index)=>{
                                item.id = index
                                return item
                            })));
                        })
                    })
                }
            },5*1000)
        },
        stopRefresh() {
            clearInterval(this.refreshTimer);
            this.refreshTimer = null;
        },
        tableRowClassName({row, rowIndex}){
            if (rowIndex === 0) {
                return 'gray-row';
            }
            return '';
        },
    },
    beforeDestroy() {
        window.removeEventListener('resize', this.getFixWidth)
    },
    destroyed() {
        this.stopRefresh()
    }
}
</script>

<style lang="scss" scoped>
    ::v-deep.el-table .gray-row{
        background-color: #f4f4f4;
    }
.mi_create_header_fixed{
    position: fixed;
    z-index: 2;
    top: 50px;
    border-bottom: solid 1px #eee;
}
.ellipsis{
    width: 100%;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    display: inline;
}
.ellipsis-row-2{
    width: 100%;
    white-space: normal;
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
}
.create_vivo_list tbody .cell div{
    overflow: hidden;
    text-overflow: ellipsis;
    display: inline;
}

.bg-wrap-color{
    background-color:#F1F4F9;
}
.bg-color{
    background-color:#FFF;
}
.mi_create_header_fixed{
    position: fixed;
    z-index: 2;
    top: 50px;
    border-bottom: solid 1px #eee;
}
</style>
